export type { ApiResponse, ServerRequestHooks } from './clients/base.client';
export { ApiError, apiFetch, setServerRequestHooks } from './clients/base.client';

// Common service client — currencies and shared platform features
export { CommonClient, commonClient } from './clients/common.client';
export type { CurrencyItem, GeoData, CountryItem } from './clients/common.client';

// Sports events service client
export { SportsEventsClient, sportsEventsClient, concertsEventsClient } from './clients/sportsevents.client';
export type {
  SearchEventsParams,
  Event,
  PaginatedEvents,
  Ticket,
  PaginatedTickets,
  GuestInfo,
  CreateBookingRequest,
  Booking,
  CheckoutSession,
  PaymentIntent,
  BookingStatus,
  PaymentStatus,
  TopCity,
  TopTournament,
  FilterOptions,
  FilterOptionItem,
  Country,
  NearbyShow,
  NearbyHotel,
  NearbySportEvent,
} from './clients/sportsevents.client';

// Auth service client
export { AuthClient, authClient } from './clients/auth.client';
export type { AuthResponse, MeResponse, MemberProfile, ProfileResponse } from './clients/auth.client';

// Hotels service client
export { HotelsClient, hotelsClient } from './clients/hotels.client';

// Restaurants service client
export { RestaurantsClient, restaurantsClient } from './clients/restaurants.client';
export type {
  SearchRestaurantsParams,
  RestaurantRecord,
  RestaurantListResponse,
  RestaurantAddress,
  RestaurantLocation,
  OpeningHourRecord,
  AvailabilitySlot,
  AvailableTable,
  BookingFlowTable,
  AvailableDateRange,
  CreateRestaurantBookingParams,
  RestaurantBooking,
  LocationSuggestion,
  CityDestIdResult,
  BookingFlowTimesBlock,
  BookingFlowTimesResponse,
  NearbySportsParams,
  NearbySportsResponse,
  NearbyShowsParams,
  NearbyShowsResponse,
  NearbyHotelsParams,
  NearbyHotelsResponse,
  NearbyRestaurantsParams,
  NearbyRestaurantRecord,
  NearbyRestaurantsResponse,
} from './clients/restaurants.client';
export type {
  HotelSearchParams,
  HotelNearbyGeoParams,
  FinalRate,
  FacetOption,
  AffiliateVenueMeta,
  RefVenueMeta,
  HotelListRecord,
  SearchListResponse,
  HotelSuggestion,
  Suggestions,
  FeaturedHotel,
  RecommendedRoom,
  PropertyDetailResponse,
  PropertyDetailParams,
  SelectedRoomRateInput,
  PrepareCartBody,
  PrepareCartResult,
  CartData,
  CartFinalRatesObj,
  BookingListItem,
  BookingsListResponse,
  BookingDetail,
  CancelBookingResult,
  ChatMessage,
  ChatMessagesResponse,
  SendChatMessageResult,
  GuestDetailsBody,
  AccessibilityRequests,
  CotAndExtraBedItem,
  CotExtraBedBand,
  InitiatePaymentResult,
  SavePaymentBody,
  SavePaymentResult,
  // Phase 0.12: UPO + cancellation types
  RateLevelUPO,
  RoomBookingUPO,
  CancellationPolicyEntry,
  CancellationChargeType,
  NearbyShowItem,
  NearbyShowsResult,
} from './clients/hotels.client';

// ─────────────────────────────────────────────────────────────────────────────
// Attractions service client (Bridgify aggregator).
//
// The service returns a NORMALISED view of Bridgify, not its wire format —
// supplier cost (`merchant_price`) and `inventory_supplier` are stripped
// server-side and so are absent from every type below.
// ─────────────────────────────────────────────────────────────────────────────
export { AttractionsClient, attractionsClient } from './clients/attractions.client';
export type {
  // catalogue
  AttractionAvailabilityType,
  AttractionGeo,
  AttractionRecord,
  AttractionListResponse,
  SearchAttractionsParams,
  AttractionCityRecord,
  AttractionAvailability,
  // step engine
  AttractionStepKind,
  AttractionFieldType,
  AttractionFieldOption,
  AttractionFieldDescriptor,
  AttractionPickupShape,
  AttractionPickupPoint,
  AttractionPickupRect,
  AttractionTicketType,
  AttractionTicketRestrictions,
  AttractionOptionalExtraValue,
  AttractionOptionalExtra,
  AttractionProductOption,
  AttractionShipmentMethod,
  AttractionStepPayload,
  AttractionBookingStep,
  AttractionCartPricing,
  AttractionCartData,
  AttractionStepsData,
  // orders / cancellation
  AttractionOrderStatus,
  AttractionVoucherStatus,
  AttractionOrderRecord,
  AttractionCancellationTerms,
  AttractionBookingStatus,
} from './clients/attractions.client';
